
import parsePhoneNumberFromString from 'libphonenumber-js'
import { i18n } from '@/locales'

const formatPhoneNational = (phone: string) => {
  const parsed = parsePhoneNumberFromString(phone)
  return parsed?.formatNational() ?? phone
}

const formatPhoneInternational = (phone: string) => {
  const parsed = parsePhoneNumberFromString(phone)
  return parsed?.formatInternational() ?? phone
}

const formatTime = (time: string) => {
  const [hours = 0, minutes = 0] = time.split(':').map(Number)

  const date = new Date()
  date.setHours(hours, minutes, 0, 0)

  return new Intl.DateTimeFormat(i18n.global.locale.value, {
    hour: 'numeric',
    minute: '2-digit'
  }).format(date)
}

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/

const toDate = (date: string) => {
  return DATE_ONLY_REGEX.test(date) ? new Date(`${date}T00:00:00`) : new Date(date)
}

const formatDate = (date: string, options: Intl.DateTimeFormatOptions = {}) => {
  return new Intl.DateTimeFormat(i18n.global.locale.value, options).format(toDate(date))
}

const formatCurrency = (value: number, currency = 'USD') => {
  return new Intl.NumberFormat(i18n.global.locale.value, {
    style: 'currency',
    currency
  }).format(value)
}

export const filters = {
  formatPhoneNational,
  formatPhoneInternational,
  formatTime,
  formatDate,
  formatCurrency
}
